import React, { useRef, useState, useEffect, Suspense } from 'react';
import { useSelector } from 'react-redux';
import useHttpApiCall from '../../../services/useHttpApiCall';
import MachineLayoutComponent from '../../../modules/machinedetail/components/machinelayout.component';
import { useLocation } from 'react-router';
import { lineProcessInstantaneousChartFilterButtons } from '../../../config/chartFilterButtons';
import widgetApiParams from '../../../utilities/widget.api.params';
import processInstantaneousPowerChartConfig from '../../../common/chartdataconfig/mainLayoutConfig/main.process.instantaneous.power.chart.config';
import RefreshMultipleTimeseries from '../../../common/chartautorefresh/refresh.multiple.timeseries';

export default function CustomPowerUsageContainer(props) {
  const INITIALFILTER = '4hr';
  const charRef = useRef(undefined);
  const [chartApiData, setChartApiData] = useState([]);
  const [payload, setPayload] = useState(undefined);
  const [payload2, setPayload2] = useState(undefined);
  const set_equipment_filter = useSelector((state) => state.equipmentFilter.set_equipment_filter);
  const [graphFilter, setGraphFilter] = useState({
    filterMain: INITIALFILTER
  });
  const onSidbarClick = useSelector((state) => state.sidebarClick.linkClick);
  const [apiParams, setApiParams] = useState(null);
  const [lastTimeStamp, setLastTimeStamp] = useState(null);
  const location = useLocation();
  const config = {
    ...processInstantaneousPowerChartConfig(chartApiData, graphFilter, props.graph_name || props.name),  legend: { enabled: false }
  };

  const graphApiCall = () => {
    setPayload({
      auth: true,
      url: props.customGraphApi,
      params: apiParams
    });
    charRef.current.chart.showLoading();
  };

  const graphAddPointApiCall = () => {
    // eslint-disable-next-line no-unused-vars
    const { duration, ...modifiedParams } = apiParams;

    setPayload2({
      auth: true,
      url: props.customGraphApi,
      params: { ...modifiedParams, last_reading_time: lastTimeStamp }
    });
  };

  useEffect(() => {
    setGraphFilter((prev) => ({
      ...prev,
      filterMain: INITIALFILTER,
      filterSecondary: graphFilterObject[INITIALFILTER].dropdown[0]
    }));
    charRef.current.chart.zoomOut();
  }, [onSidbarClick]);

  useEffect(() => {
    graphApiCall();
  }, [apiParams]);

  useEffect(() => {
    if (set_equipment_filter.filter_update) {
      graphApiCall();
    }
  }, [set_equipment_filter.filter_update]);

  useEffect(() => {
    setApiParams(widgetApiParams('ProcessInstantaneousPower', props, graphFilter));
  }, [graphFilter, location.pathname,props?.plant_code]);

  const graphFilterObject = lineProcessInstantaneousChartFilterButtons;
  const [data, loading] = useHttpApiCall(payload);
  useEffect(() => {
    if (data && data.data) {
      let apiData = data.data.data;
      setChartApiData(apiData);
      setLastTimeStamp(apiData.last_updated_time);
      charRef.current.chart.hideLoading();
    }
  }, [data]);

  return (
    <div>
      <Suspense fallback={<span>Loadiing</span>}>
        <MachineLayoutComponent
          chartApiData={chartApiData}
          loading={loading}
          chartData={config}
          charRef={charRef}
          expandWindow={props.expandWindow}
          minimizeWindow={props.minimizeWindow}
          shouldExpand={props.shouldExpand}
          chartId={props.id}
          hasFilter={true}
          graphFilter={graphFilter}
          setGraphFilter={setGraphFilter}
          graphFilterObject={graphFilterObject}
        />
        <RefreshMultipleTimeseries
          data={data}
          payload2={payload2}
          charRef={charRef}
          apiParams={apiParams}
          chartApiData={chartApiData}
          setChartApiData={setChartApiData}
          lastTimeStamp={lastTimeStamp}
          setLastTimeStamp={setLastTimeStamp}
          graphApiCall={graphApiCall}
          graphAddPointApiCall={graphAddPointApiCall}
        />
      </Suspense>
    </div>
  );
}
